import Error from '../model/Error';
import axios from 'axios';

export default class ApplicationMemberRepository {
    static update(applicationMember) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/application-member/${applicationMember.id}`, applicationMember.serialize())
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
